import { EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { of, timer } from 'rxjs';
import * as moment from 'moment';
import { ApiService } from '../../../../../services/api.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import Decimal from 'decimal.js-light';
import { TranslateService } from '@ngx-translate/core';
var DocumentIssueFormComponent = (function () {
    function DocumentIssueFormComponent(formBuilder, apiService, translateService) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.apiService = apiService;
        this.translateService = translateService;
        this.data = new EventEmitter();
        this.username = localStorage.getItem('username');
        this.documentNoValidator = function (control) {
            var sellerForm = control.get('sellerForm');
            var documentForm = control.get('documentForm');
            var sellerTaxID = sellerForm.value ? sellerForm.value['taxID'] : null;
            var documentNo = documentForm.value ? documentForm.value['documentNo'] : null;
            var params = {
                seller_tax_id: sellerTaxID,
                document_no: documentNo
            };
            return timer(300).pipe(switchMap(function () {
                return _this.apiService.checkMatchedInvoiceNumber(params).pipe(map(function (res) { return (res.duplicate ? { duplicateDocumentNo: { value: 'Duplicate Document Number' } } : null); }), catchError(function () { return of(null); }));
            }));
        };
    }
    DocumentIssueFormComponent.prototype.ngOnInit = function () {
        this.createDocumentIssueForm();
    };
    Object.defineProperty(DocumentIssueFormComponent.prototype, "currentLang", {
        get: function () {
            return this.translateService.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    DocumentIssueFormComponent.prototype.submit = function () {
        if (this.documentIssueForm.valid) {
            var documentIssue = this.documentIssueForm.value;
            var seller = documentIssue.sellerForm;
            var document_1 = documentIssue.documentForm;
            var buyer = documentIssue.buyerForm;
            var lineItem = documentIssue.lineItemForm;
            if (lineItem.correctAmount.includes('-') || !lineItem.matchedABB) {
                return;
            }
            var data = {
                file_type: this.document.type || '',
                department: document_1.department || '',
                document_number: document_1.runningNo || '',
                branch_code: seller.branchCode || '',
                branch_name: seller.branchName || '',
                invoice_number: document_1.documentNo || '',
                issue_dt: moment(document_1.documentDate).format('YYYY-MM-DD') + 'T' + moment().startOf('day').format('HH:mm:ss'),
                purpose: document_1.purpose || '',
                abb_no: document_1.abbNo || '',
                confirmation_no: document_1.confirmationNo || '',
                pay_option: lineItem.paymentOption || '',
                document_request_id: document_1.documentRequest,
                order_no: document_1.orderNo || '',
                reference: document_1.referenceDocuments.map(function (referenceDocument) {
                    return ({
                        ref_date: referenceDocument.documentDate ? moment(referenceDocument.documentDate).format('YYYY-MM-DD') + 'T' + moment().startOf('day').format('HH:mm:ss') : '',
                        ref_doc_no: referenceDocument.documentNo || '',
                        ref_doc_type: referenceDocument.documentType || ''
                    });
                }),
                seller: {
                    name_th: seller.name || '',
                    name_en: seller.nameEN || '',
                    tax_id: seller.taxID || '',
                    address_th: seller.address || '',
                    address_en: seller.addressEN || '',
                    post_code: seller.postalCode || '',
                },
                buyer: {
                    name: buyer.name || '',
                    tax_id: buyer.taxID || '',
                    branch_code: buyer.branchCode || '',
                    branch_name: buyer.branchName || '',
                    address: buyer.address || '',
                    post_code: buyer.postalCode || '',
                    country_code: buyer.country || '',
                    email: buyer.email || '',
                    cc_email: buyer.ccEmail || ''
                },
                line_items: lineItem.items.map(function (item, index) { return ({
                    item_number: String(index + 1),
                    product_id: item.productID || '',
                    product_name: item.description || '',
                    quantity: item.quantity || '0',
                    unit: item.unit || '',
                    unit_price: item.unitPrice || '0',
                    net_discount_or_charge: item.discount || '0',
                    net_total_amount: item.total,
                    line_vat: item.lineVAT || 'non-vat',
                    note: item.note || '',
                }); }),
                total_items: {
                    line_total_amount: (new Decimal(lineItem.subTotal).minus(new Decimal(lineItem.discountTotal))).toFixed(2),
                    line_total_amount_after_discount: lineItem.balance,
                    percent_vat: lineItem.percentVAT || '',
                    vat: lineItem.vat,
                    non_vat_amount: lineItem.nonVATAmount,
                    vat_0_amount: lineItem.vat0Amount,
                    vat_amount: lineItem.vatAmount,
                    total_payment: lineItem.netTotal,
                    discount_or_charge: lineItem.endOfBillDiscount || '0',
                    discount_or_charge_reason: lineItem.discountReason || '',
                    original_amount_before_vat: lineItem.originalAmount || '',
                    original_amount_vat: lineItem.originalVAT || '',
                    correct_amount: lineItem.correctAmount || '',
                    difference_amount: lineItem.balance || '',
                    payment_methods: lineItem.paymentMethods,
                }
            };
            this.data.emit(data);
        }
    };
    DocumentIssueFormComponent.prototype.createDocumentIssueForm = function () {
        this.documentIssueForm = this.formBuilder.group({
            sellerForm: [],
            documentForm: [],
            buyerForm: [],
            lineItemForm: []
        }, { asyncValidator: this.documentNoValidator });
        if (this.documentInformation) {
            if (this.docProcessType === 'reissue') {
                this.updateReissueDocumentForm(this.documentInformation);
            }
            else if (this.docProcessType === 'request') {
                this.onDocumentRequestSelected(this.documentInformation);
                this.updateDocumentForm(this.documentInformation);
            }
        }
        else if (this.abbData) {
            this.abbData.id = undefined;
            this.updateDocumentForm(this.abbData);
        }
    };
    DocumentIssueFormComponent.prototype.onDocumentRequestSelected = function (event) {
        var buyerForm = this.documentIssueForm.get('buyerForm');
        buyerForm.patchValue({
            name: event ? event.buyer_name : null,
            taxID: event ? event.tax_id : null,
            branchCode: event ? event.branch_code : null,
            branchName: event ? event.branch_name : null,
            address: event ? event.address : null,
            postalCode: event ? event.postal_code : null,
            country: event ? event.country_code : null,
            email: event ? event.email : null,
            ccEmail: event ? event.cc_email : null,
        });
    };
    DocumentIssueFormComponent.prototype.updateDocumentForm = function (event) {
        var documentType = this.document.type.length === 1 ? this.document.type[0].value : null;
        var documentForm = this.documentIssueForm.get('documentForm');
        documentForm.patchValue({
            documentNo: null,
            documentDate: event.issue_dt ? new Date(event.issue_dt) : new Date(),
            abbNo: event.abb_no ? event.abb_no : null,
            confirmationNo: null,
            documentRequest: event.id ? event.id : null,
            orderNo: null,
            runningNo: null,
            purpose: null,
            referenceDocuments: [{
                    documentNo: null,
                    documentType: documentType,
                    documentDate: null
                }]
        });
    };
    DocumentIssueFormComponent.prototype.updateReissueDocumentForm = function (event) {
        this.selectedDocumentType = 'receipt_tax_invoice';
        var documentForm = this.documentIssueForm.get('documentForm');
        var buyerForm = this.documentIssueForm.get('buyerForm');
        documentForm.patchValue({
            documentNo: event.header.invoice_number,
            documentDate: new Date(),
            abbNo: null,
            orderNo: event ? event.header.order_no : null,
            purpose: event ? this.processPurpose(event) : null,
            confirmationNo: null,
            documentRequest: null,
            runningNo: null,
            department: event ? event.header.department : null,
            referenceDocuments: event.rd_document_type === 'receipt_tax_invoice' ? [{
                    documentNo: event ? event.header.invoice_number : null,
                    documentType: 'receipt_tax_invoice',
                    documentDate: event ? new Date(event.header.issue_dt) : null
                }] : [{
                    documentNo: null,
                    documentType: null,
                    documentDate: null
                }]
        });
        documentForm.updateValueAndValidity();
        buyerForm.patchValue({
            name: event ? event.buyer.name : null,
            taxID: event ? event.buyer.tax_id.slice(0, 13) : null,
            branchCode: event ? event.buyer.tax_id.slice(-5) : null,
            branchName: event ? event.buyer.branch_name : null,
            address: event ? event.buyer.address : null,
            postalCode: event ? event.buyer.post_code : null,
            country: event ? event.buyer.country_code : null,
            email: event ? event.buyer.email : null,
            ccEmail: event ? event.buyer.cc_email : null,
        });
    };
    DocumentIssueFormComponent.prototype.processPurpose = function (event) {
        if (event.rd_document_type !== 'receipt_tax_invoice') {
            if (event.header) {
                return event.header.purpose;
            }
            return null;
        }
        var issueDate = new Date(event.header.issue_dt);
        var issueDateDisplay = moment(issueDate).format('YYYY-MM-DDTHH:mm:ss') + ' GMT +7:00';
        return "\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01 \u0E41\u0E25\u0E30\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35\u0E09\u0E1A\u0E31\u0E1A\u0E43\u0E2B\u0E21\u0E48\u0E41\u0E17\u0E19\u0E09\u0E1A\u0E31\u0E1A\u0E40\u0E14\u0E34\u0E21\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48 " + event.header.invoice_number + " \u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 " + issueDateDisplay;
    };
    DocumentIssueFormComponent.prototype.onAbbDataSelected = function (event) {
        this.abbData = event;
    };
    return DocumentIssueFormComponent;
}());
export { DocumentIssueFormComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-issue-form/document-issue-form.component.ts.pre-build-optimizer.js